module.exports = __webpack_public_path__ + "img/10979927_L.5d881021.png";